import React, {useCallback, useEffect, useState} from 'react';

import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-enterprise/base.css'
import '@inovua/reactdatagrid-enterprise/theme/default-light.css'
import DateFilter from '@inovua/reactdatagrid-community/DateFilter'
import SelectFilter from "@inovua/reactdatagrid-community/SelectFilter";
import * as icons from '../Icons/Icons';

import {observer} from "mobx-react";
import moment from "moment";
import {api} from "../../config";
import SessionStore from "../../stores/SessionStore";
import {toggleDrawer} from "../../helpers/helpers";
import Drawer from "../Drawer/Drawer";
import ReportStore from "../../stores/ReportStore";
import ScheduleStore from "../../stores/ScheduleStore";
import IncidentForm from "./IncidentForm";
import ManagerStore from "../../stores/ManagerStore";
import { isAuthorized } from '@smarterservices/iam-react-client';

const filterValue = [
  { name: 'exam.title', operator: 'contains', type: 'string', value: '' },
  { name: 'status', operator: 'contains', type: 'select', value: 'Scheduled' },
  { name: 'appointmentDate', operator: 'equals', type: 'date', value: ''},
  { name: 'location.type.type', operator: 'equals', type: 'select', value: '' },
  { name: 'exam.type', operator: 'equals', type: 'select', value: '' },
  { name: 'name', operator: 'contains', type: 'string', value:''},
  { name: 'enrollment.email', operator: 'contains', type: 'string', value:''},
  { name: 'course.instructor.email', operator: 'contains', type: 'string', value:''},
  { name: 'course.instructor.name', operator: 'contains', type: 'string', value:''},
  { name: 'course.code', operator: 'contains', type: 'string', value:''},
  { name: 'course.title', operator: 'contains', type: 'string', value:''},
  { name: 'course.offering.title', operator: 'contains', type: 'string', value:''},
  { name: 'location.name', operator: 'contains', type: 'string', value:''},
  { name: 'appointment.seat.title', operator: 'contains', type: 'string', value:''}

];
const statuses = [{label: "Scheduled", id: "Scheduled"}, {label: "Cancelled", id: "Cancelled"},{label: "Closed", id:"Closed"},{label: "Checked In", id: "Checked In"}, {label: "In Progress", id: "In Progress"}]
const sessionTypes = [{label: "In Person", id: "in-person"}, {label: "Live Virtual", id: "online"}]
const examTypes = [{label: "Written", id: "Written"}, {label: "Computer Based", id: "Online"}]
const gridStyle = { minHeight: 500 };

const Sessions = observer((props) => {
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(50);
  const [filterObject, setFilterObject] = useState(filterValue);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [session, setSession] = useState(null);
  const [update, setUpdate] = useState(false);
  const [sort, setSort] = useState(null);

  const columns = [
    {
      name: 'sid',
      header: 'Id',
      defaultVisible: false,
      type: 'number',
      defaultWidth: 50,
    },
    {
      name: 'name',
      header: "Student",
      type: 'string',
      defaultFlex: .5,
      render: ({data}) => {
        return <span>{data.enrollment.firstName} {data.enrollment.lastName}</span>
      },
      enableColumnFilterContextMenu: false,
    },
    {
      name: 'appointmentDate',
      header: 'Start Date',
      filterEditor: DateFilter,
      dateFormat: 'MM/DD/YYYY',
      render: ({ data }) => {
        return <span>{moment(data.appointmentDate).format('MM/D/YYYY')}</span>;
      },
      enableColumnFilterContextMenu: false,
    },
    {
      name: 'startTime',
      header: 'Start Time',
      type: 'string',
      render: ({ data }) => {
        return <span>{moment(data.appointmentDate).format('hh:mm A')}</span>;
      }
    },
    {
      name: 'exam.title',
      header: 'Exam Title',
      defaultFlex: 1,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        if(data.exam){
          return <span>{data.exam.title}</span>;
        }
      }
    },
    {
      name: 'status',
      header: 'Status',
      filterEditor: SelectFilter,
      filterEditorProps: {
        placeholder: 'All',
        dataSource: statuses,
      },
      enableColumnFilterContextMenu: false,
    },
    {
      name: 'location.type.type',
      header: 'Session Type',
      filterEditor: SelectFilter,
      filterEditorProps: {
        placeholder: 'All',
        dataSource: sessionTypes,
      },
      render: ({ data }) => {
        let type = data.location.type.type
        //Reg ex to capitalize the first letter of each word in this case it would be in-person or online(and remove hyphens)
        type = type.replace(/\b\w/g, char => char.toUpperCase());
        type = type.replace(/-/g, ' ');

        if(type === "Online"){
          return <span>Live Virtual</span>;
        } else {
          return <span>{type}</span>;
        }
      },
      enableColumnFilterContextMenu: false

    },
    {

      name: 'examConfiguration.type',
      header: 'Accommodation',
      render: ({ data }) => {
        if(data.examConfiguration.type === 'accommodation'){
          return (
            <icons.iconCheck />
          )
        } else {
          return (
            <icons.iconTimes/>
          )
        }

      },
      enableColumnFilterContextMenu: false,
      sortable: false,
    },
    {
      name: 'course.instructor.email',
      header: 'Instructor Email',
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        return <span>{data.course.instructor.email}</span>;
      }
    },
    {
      name: 'course.instructor.name',
      header: 'Instructor Name',
      defaultFlex: 1,
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        return <span>{data.course.instructor.firstName} {data.course.instructor.lastName}</span>;
      }
    },
    {
      name: 'enrollment.email',
      header: `Tester's Email`,
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        return <span>{data.enrollment.email}</span>;
      }
    },
    {
      name: 'course.title',
      header: `Course Name`,
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        return <span>{data.course.title}</span>;
      }
    },
    {
      name: 'configuration.examOpenDate',
      header: `Exam Open/Close`,
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        return <span>{moment(data.examConfiguration.examOpenDate).format('MM/DD/YYYY')} - {moment(data.examConfiguration.examCloseDate).format('MM/DD/YYYY') }</span>;
      }
    },
    {
      name: 'configuration.duration',
      header: `Exam Duration`,
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        return <span>{data.examConfiguration.duration}</span>;
      }
    },
    {
      name: 'course.code',
      header: `Course Code`,
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        return <span>{data.course.code}</span>;
      }
    },
    {
      name: 'exam.type',
      header: `Exam Type`,
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      filterEditor: SelectFilter,
      filterEditorProps: {
        placeholder: 'All',
        dataSource: examTypes,
      },
      render: ({ data }) => {
        if(data.exam){
          if(data.exam.type === "Online"){
            return <span>Computer Based</span>;
          } else {
            return <span>{data.exam.type}</span>;
          }
        }
      }
    },
    {
      name: 'course.offering.title',
      header: `Course Offering`,
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        return <span>{data.course.offering.title}</span>;
      }
    },
    {
      name: 'location.name',
      header: `Proctoring Location`,
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        return <span>{data.location.name}</span>;
      }
    },
    {
      name: 'appointment.seat.title',
      header: `Seat`,
      defaultFlex: 1,
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        if(data.appointment && data.appointment.seat){
          return <span>{data.appointment.seat.title}</span>;
        }
      }
    },
    {
      name: 'sessionReportCount',
      header: `Incidents`,
      defaultVisible: false,
      enableColumnFilterContextMenu: false,
      render: ({ data }) => {
        if(data.sessionReportCount > 0){
          return <span>{data.sessionReportCount}</span>;
        }
      }
    },
  ];

  const completeIncident = () => {
    const { ManagerStore, SessionStore } = props.store;
    ManagerStore.reportIncident = false;
    SessionStore.showToaster("Incident Saved", 'success');
  }

  const formatAppointmentDate = (date, addDay = false) => {
    const dateString = moment(date).format('YYYY-MM-DD HH:mm');
    const timezoneString = moment(date).local().tz(moment.tz.guess()).format('Z');
    let newDate = moment.utc(`${dateString} ${timezoneString}`, 'YYYY-MM-DD HH:mm Z')
      .tz(moment.tz.guess())
      .toISOString();

      if (addDay) {
        return moment(newDate).add(1, 'd').toISOString();
      } else return newDate;
  }

  const loadData = ({skip, limit}) => {
    setLimit(limit)
    setSkip(skip)
    let query = '?limit=' + limit
    filterObject.map(object => {
      if(object.value && object.value.length > 0){
        switch (object.name){
          case "appointmentDate":
            query += `&appointmentStartDate=${formatAppointmentDate(object.value)}&appointmentEndDate=${formatAppointmentDate(object.value, true)}`
            break;
          case "configuration.examOpenDate":
            query += `&examOpenDate=${object.value}`
            break;
          case "configuration.examCloseDate":
            query += `&examCloseDate=${object.value}`
            break;
          case "status":
            query += `&status=${object.value}`
            break;
          case "location.type.type":
            query += `&locationType=${object.value}`
            break;
          case "name":
            query+= `&name=${object.value}`
            break;
          case "exam.title":
            query += `&examTitle=${object.value}`
            break;
          case "exam.type":
            query+= `&examType=${object.value}`
            break;
          case "course.instructor.name":
            query+= `&instructorName=${object.value}`
            break;
          case "course.code":
            query+= `&courseCode=${object.value}`
            break;
          case "course.instructor.email":
            query+= `&instructorEmail=${object.value}`
            break;
          case "course.title":
            query+= `&courseTitle=${object.value}`
            break;
          case "course.offering.title":
            query+= `&courseOffering=${object.value}`
            break;
          case "enrollment.email":
            query+= `&testerEmail=${object.value}`
            break;
          case "location.name":
            query+= `&locationName=${object.value}`
            break;
          case "appointment.seat.title":
            query+= `&seatName=${object.value}`
            break;
          default:
            break;
        }
      }
      return null;
    })
    let url = `/proctors/${SessionStore.userData.proctorAccountSid}/sessions${query}`
    if(sort){
      let sortDirection = sort.dir === 1 ? 'asc' : 'desc';
      let columnName = sort.columnName;

      url += `&sort=${columnName}&sortDir=${sortDirection}`
    }
    ReportStore.reportUrl = url;
    url += ('&offset=' + skip)
   return api.get(url).then(response => {
      return {data: response.data.results, count: response.data.total};
    })
  }

  let dataSource = useCallback(loadData, [skip, filterObject, limit, ScheduleStore.session, update, sort])

  const onRowClick = (rowProps, event) => {

    setSession(rowProps.data.sid);
    ScheduleStore.getSingleSession(rowProps.data.sid);
    setDrawerOpen(true);
    toggleDrawer(null, null, 'SessionDetail')

  }
  const exportCSV = () => {

    const { SessionStore } = props.store;

    SessionStore.exportSessionsCSV()
  }

  useEffect(() => {
    const { proctorAccountSid } = SessionStore.userData;
    const iam = sessionStorage.getItem('iam');

    if (!isAuthorized('sp:DescribeExamSessions', `ssrn:ss:sp::${proctorAccountSid}:session`, iam)) {
      props.routing.history.push('/unauthorized');
    }
  }, [])

  return (
      <main tabIndex="0" id="main-content" className="page fill">
        <div className='fill'>
          <div class="split-row-container">
            <div className="left">
              <h1>Sessions</h1>
              <p>Click on any session's row to view its details</p>
            </div>
            <div className='right'>
              <button className="btn--outline " onClick={exportCSV}>
                Export CSV
              </button>
            </div>
          </div>

          {session && drawerOpen &&
            <Drawer
            content="SessionDetail"
            isOpen={drawerOpen}
            parent={this}
            sessionSid={session}
            noInteract={false}
            callback={() => setDrawerOpen(false)}
            timeline={true}
            refreshEvents={() => setUpdate(!update)}
            {...props}
            />
          }

          <ReactDataGrid
              className="reactDataGrid fill"
              style={gridStyle}
              idProperty="id"
              columns={columns}
              dataSource={dataSource}
              defaultFilterValue={filterValue}
              onFilterValueChange={setFilterObject}
              onSortInfoChange={setSort}
              onSkipChange={setSkip}
              onLimitChange={setLimit}
              limit={limit}
              skip={skip}
              onRowClick={onRowClick}
              pagination={true}

          />
        </div>

        {ManagerStore.reportIncident && session &&
          <div className={`session-interact  ${ManagerStore.reportIncident ? 'active' : ''}`}>
            <div className="panel--brief --xlarge">

            <IncidentForm
              installSid={session.installSid}
              examSid={session.examSid}
              complete={completeIncident}
              {...props}
            />
            </div>
          </div>
        }
    </main>
  )
}); export default (Sessions);


// WEBPACK FOOTER //
// ./src/app/components/Sessions/Sessions.js